import { render } from "./BibleQuote.vue?vue&type=template&id=49bda85d"
import script from "./BibleQuote.vue?vue&type=script&lang=js"
export * from "./BibleQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__